/**
 * Features:
 * - §14.4.5 success art: ink circle with an accent tick — request submitted,
 *   collection confirmed. Text still carries the meaning (never colour alone).
 */
import {
  ILLUSTRATION_ACCENT,
  PortalIllustration,
  type PortalIllustrationProps,
} from './portal-illustration';

type Props = Omit<PortalIllustrationProps, 'viewBox' | 'children'>;

export function SuccessTickIllustration(props: Props) {
  return (
    <PortalIllustration viewBox="0 0 96 96" {...props}>
      <circle cx="48" cy="48" r="34" />
      <circle cx="48" cy="48" r="26" strokeDasharray="2 6" />
      <path d="M34 49l10 10 18-22" stroke={ILLUSTRATION_ACCENT} strokeWidth={3} />
    </PortalIllustration>
  );
}
